export default '/src/assets/webgl/music/music.mp3'